import React from 'react';
import styled from '@emotion/styled';
import { SuccessOrderConfirmation } from '@css-xp/ppc-purchase-experience';
import { successVariants } from '../order-confirmation-container';
import { NewSiteSuccessContent, ExistingSiteSuccessContent, NewAndExistingSiteSuccessContent } from './content';

const StyledContentRow = styled.div({
  marginBottom: '15px',
});

export type SuccessOrderConfirmationProps = {
  variant: string;
  onGetStartedClick: () => void;
  isExistingSiteNewOrderItem?: boolean;
  isDesignIteration1Enabled?: boolean;
};

export const SuccessOrderConfirmationContainer = ({
  variant,
  onGetStartedClick,
  isExistingSiteNewOrderItem,
  isDesignIteration1Enabled,
}: SuccessOrderConfirmationProps) => {
  const content = () => {
    switch (variant) {
      case successVariants.NEW_SITE: {
        return (
          <NewSiteSuccessContent
            onGetStarted={onGetStartedClick}
            isDesignIteration1Enabled={isDesignIteration1Enabled}
          />
        );
      }
      case successVariants.EXISTING_SITE: {
        return (
          <ExistingSiteSuccessContent
            isExistingSiteNewOrderItem={isExistingSiteNewOrderItem}
            isDesignIteration1Enabled={isDesignIteration1Enabled}
          />
        );
      }
      case successVariants.NEW_AND_EXISTING_SITE: {
        return (
          <NewAndExistingSiteSuccessContent
            onGetStarted={onGetStartedClick}
            isDesignIteration1Enabled={isDesignIteration1Enabled}
          />
        );
      }
    }
  };

  return <SuccessOrderConfirmation content={content()} />;
};
